import React from 'react';
import { installSessionHandling } from './utils/sessionExpiry';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { captureAttribution, installAttributionHooks } from './services/attribution';
import { installProductEventHooks } from './services/productEvents';

installSessionHandling();
captureAttribution();
installAttributionHooks();
installProductEventHooks();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);

reportWebVitals();
